import { useQuery } from '@tanstack/react-query'
import { lerModoCodigo } from '@/api/waf'

/** Carga do modo código do WAF: vínculo com o stage e divergências com a AWS. */
export function useModoCodigo(wafId: number) {
  return useQuery({
    queryKey: ['waf-codigo', wafId],
    queryFn: () => lerModoCodigo(wafId),
    staleTime: 60_000,
    enabled: Number.isFinite(wafId) && wafId > 0,
  })
}
